import Flag from '@atlaskit/flag';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import React from 'react';
// import ScreenEventAnalytics from '../../../../../common/analytics/components/screen-event-analytics';
// import { AnalyticsEventSource } from '../../../analytics/constants';
import { AccessRequestLink, ChatRoomLink } from '../help-links';
import './unauthorized.scss';
import { ErrorTypeEnum } from '../constants';

const contents = (
  <p>
    You are not authorized to access this section of Advocate Central. Please{' '}
    <AccessRequestLink>raise an access request</AccessRequestLink> with your business justification or ping the{' '}
    <ChatRoomLink /> if you believe your access has recently changed.
  </p>
);

export const Unauthorized = ({ description }: { description?: React.ReactNode }) => (
  <div className="not-found" data-testid="unauthorized">
    {/* <ScreenEventAnalytics
            event={{
                name: AnalyticsEventSource.UNAUTHORIZED_SCREEN
            }}
        /> */}
    <Flag
      title="Access Denied"
      description={description || contents}
      appearance="normal"
      id="server-error"
      icon={<WarningIcon label="Access Denied" />}
    />
  </div>
);

// this is used by error-wrapper for identifying the component
Unauthorized.displayName = ErrorTypeEnum.UNAUTHORIZED;
